import { useTheme } from "@mui/material/styles";
import {
  useMediaQuery,
  Grid,
  List,
  ListItem,
  Stack,
  Typography,
  Divider,
} from "@mui/material";

// project import
import MainCard from "components/MainCard";
import { FormattedMessage, useIntl } from "react-intl";
import { VacancyPackage } from "../../../../../../types/orders-managment/packages";

const ExpandingVacancyDetail = ({ data }: { data: VacancyPackage }) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down("md"));
  const intl = useIntl();

  return (
    <Grid
      container
      spacing={3.5}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Grid item xs={12} sm={7} md={12} xl={8.5}>
        <Stack spacing={2.5}>
          <MainCard title={<FormattedMessage id="Vacancy Package Details" />}>
            <List sx={{ py: 0 }}>
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Id" />
                      </Typography>
                      <Typography>{data.id}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Created at" />
                      </Typography>
                      <Typography>{data.created_at}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Package Type" />
                      </Typography>
                      <Typography>{data.type}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Vacancies Count" />
                      </Typography>
                      <Typography>{data.count}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Fees" />
                      </Typography>
                      <Typography>{data.fees}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Price Per Unit" />
                      </Typography>
                      <Typography>{data.price_per_unit}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Package Validity" />
                      </Typography>
                      <Typography>{data.package_validity} days</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Package Duration" />
                      </Typography>
                      <Typography>{data.package_duration} days</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="English Note" />
                      </Typography>
                      <Typography>{data.note}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem divider={!matchDownMD}>
                <Grid item xs={12}>
                  <Stack spacing={0.5}>
                    <Typography color="secondary">
                      <FormattedMessage id="Arabic Note" />
                    </Typography>
                    <Typography>{data.note_trans?.ar}</Typography>
                  </Stack>
                </Grid>
              </ListItem>
            </List>
          </MainCard>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default ExpandingVacancyDetail;
